import React, { useEffect } from 'react'
import { UserColumns, IListParams, UserTypes, ICustomer } from '../../../shared/models/adminModels';
import { connect } from 'react-redux';
import { getCustomersList, updateManageSearchParams } from '../../../store/actions/management';
import Table from '../../../components/Table';
import { Row } from 'react-table';
import { IModulesPermissions } from '../../../shared/models/rolesPermissionModel';
import { get } from 'lodash';
import BackButton from '../../../components/BackButton';

const customerColumns = [

  {
    Header: 'Customer Name',
    accessor: UserColumns.CustomerName,
  },
  {
    Header: 'Email Address',
    accessor: UserColumns.Email,
  },
  {
    Header: 'Customer Id',
    accessor: UserColumns.CustomerId,
  },
  // {
  //     Header: 'Country',
  //     accessor: UserColumns.Country,
  // },
  {
    Header: 'Contact Person',
    accessor: UserColumns.ContactFirstName,
    Cell: (props: any) => props.cell.row.original.contactFirstName + ' ' + props.cell.row.original.contactSurname
  },
  {
    Header: 'Telephone',
    accessor: UserColumns.Telephone,
    Cell: (props: any) => props.cell.value || '-',
  },
  {
    Header: 'Country',
    accessor: UserColumns.Country,
    Cell: (props: any) => props.cell.value || '-',
  },
  {
    Header: 'County',
    accessor: UserColumns.County,
    Cell: (props: any) => props.cell.value || '-',
  },
  {
    Header: 'Status',
    accessor: UserColumns.Active,
    Cell: (props: any) => (
      <div className="active-status-wrp d-flex">
        {/* {props.cell.value ? 'Active' : 'Inactive'} */}
        <span className={(props.cell.value ? 'active-status' : 'inactive-status') + ' ml-2'}></span>
      </div>
    )
  },
];

interface IProps {
  permission: IModulesPermissions;
  history: any;
  getCustomersList: (param: IListParams) => void,
  customerList: any,
  isLoading: boolean,
  updateManageSearchParams: (params: IListParams, userType: UserTypes) => void
}

const Customer = (props: IProps) => {
  const {
    totalPages: customerTotalPages,
    data: customerData,
    pageSize: customerPageSize,
    orderBy: customerOrderBy,
    currentPage: customerCurrentPage,
    searchParameter: customerSearchParameter,
    sortType: customerSortType
  } = props.customerList;

  let customerList: any = [];

  if (customerData.length) {
    customerList = props.customerList.data.map((customer: ICustomer) => {
      return {
        [UserColumns.Id]: customer.id,
        [UserColumns.CustomerId]: customer.customerId,
        [UserColumns.CustomerName]: customer.customerName,
        [UserColumns.ContactFirstName]: customer.contactFirstName,
        [UserColumns.ContactSurName]: customer.contactSurname,
        [UserColumns.Telephone]: customer.telephone,
        [UserColumns.Email]: customer.email,
        [UserColumns.Country]: customer.country,
        [UserColumns.County]: customer.county,
        [UserColumns.Active]: customer.active
      }
    });
  }

  // get customerList
  const getCustomerList = async (saerchParams: IListParams) => {
    await props.getCustomersList(saerchParams);
  }

  const onRowClick = (row: Row<any>) => {
    props.history.push(`/manage-customer/${row.original.id}`)
  }
  useEffect(() => {
    getCustomerList({
      currentPage: customerCurrentPage,
      pageSize: customerPageSize,
      orderBy: customerOrderBy,
      searchParameter: customerSearchParameter,
      sortType: customerSortType
    });
  }, []);
  const canEdit = get(props.permission.manageCustomer, 'edit', false);
  const canAdd = get(props.permission.manageCustomer, 'create', false);
  return (
    <div className="container-fluid width-control">
      <div className="page-header">
        <h1>Customer Management</h1>
        <BackButton />
        {canAdd && <button type="button" className="btn btn-primary ml-auto" onClick={() => props.history.push('/manage-customer')}>Add</button>}
      </div>


      <div className="page-content">
        <div className="row">
          <div className="col-xl-12">
            <div className="info-box ">
              <div className="table-responsive p-1 management-tbl">
                <Table
                  headerclass={"box-shaddow box-padding border-btm-blue"}
                  rowClass={"box-shaddow box-padding"}
                  columns={customerColumns}
                  data={customerList}
                  fetchData={getCustomerList}
                  totalPages={customerTotalPages}
                  isLoading={props.isLoading}
                  currentPage={customerCurrentPage}
                  pageSize={customerPageSize}
                  orderBy={customerOrderBy}
                  searchParameter={customerSearchParameter}
                  sortType={customerSortType}
                  userType={UserTypes.CUSTOMER}
                  onRowClick={canEdit ? onRowClick : undefined}
                  updateSearchParams={props.updateManageSearchParams}
                />
              </div>
            </div>
          </div>


        </div>
      </div>



    </div>
  )
}

const mapStateToProps = (state: any) => {
  return ({
    permission: state.auth.user.permission,
    customerList: state.managementReducer.customerList,
    isLoading: state.common.isLoading
  })
}

const mapDispatchToProps = (dispatch: any) => ({
  getCustomersList: (params: IListParams) => dispatch(getCustomersList(params)),
  updateManageSearchParams: (params: IListParams, userType: UserTypes) => dispatch(updateManageSearchParams(params, userType))
});

export default connect(mapStateToProps, mapDispatchToProps)(Customer)
